import { Theme, Typography, makeStyles } from "@material-ui/core"
import { LanguageSwitch } from "../../components/LanguageSwitch"
import Stack from "../../components/Stack"

const InvitationEmailLanguageSwitch = ({
  shouldShowLanguageSwitch,
  language,
  onChangeLanguage,
  translations,
}: InvitationEmailLanguageSwitchProps) => {
  const classes = useStyles()
  if (!shouldShowLanguageSwitch) return null
  return (
    <Stack spacing={0} direction="column" alignItems="stretch" className={classes.invitationLanguageSwitch}>
      <LanguageSwitch onChangeLanguage={onChangeLanguage} value={language} />
      <Typography variant="caption" color="textSecondary" style={{ marginLeft: 8, flex: 1 }}>
        {translations.invitationLanguageDescription}
      </Typography>
    </Stack>
  )
}

type InvitationEmailLanguageSwitchProps = {
  language: string
  onChangeLanguage: (language: string) => void
  shouldShowLanguageSwitch: boolean
  translations: {
    invitationLanguageDescription: string
    note: string
  }
}

const useStyles = makeStyles((theme: Theme) => ({
  invitationLanguageSwitch: {
    "& .MuiAlert-root": {
      border: "1px solid #f0f0f0",
      width: "100%",
      marginTop: 4,
    },
  },
}))

export default InvitationEmailLanguageSwitch
